const keys = {
    GET_ALERTS: '/alerts',
    GET_UNREAD_ALERTS: '/alerts/count/unread'
};

export default keys;

